import { Component, OnInit, DoCheck, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Step } from '../../models/steps';
import { Form } from '../../models/form';

import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-steps-wizard',
  templateUrl: './steps-wizard.component.html',
  styleUrls: ['./steps-wizard.component.scss']
})
export class StepsWizardComponent implements OnInit {
  private typeWithForm = ["InputText", "InputSelect", "TextArea", "Checkbox", "RadioBox", "ComboBox", "Toggle"];



  @Input() steps: Step;
  @Input() form: {
    form: Array<Form>,
    params: any
  }
  @Output() nextStep: EventEmitter<any> = new EventEmitter(true);
  @Output() backStep: EventEmitter<any> = new EventEmitter(true);
  @Output() getForm: EventEmitter<any> = new EventEmitter(true);

  private data = {};
  public formGroup: FormGroup;

  public enableButtons = false;

  testinput = "";

  private currentConf: string = null;

  private dataKeys = [];

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    console.log(this.steps);
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.steps);
    if (this.form) {
      this.initFormCtrl()
    }
    if (this.steps.then) {
      for (let step of this.steps.then) {
        if (this.testCondition(step)) {
          if (this.currentConf != step.conf) {
            this.currentConf = step.conf;
            this.getForm.emit(this.currentConf);
          }
        }
      }
    }
  }


  next(nextStep) {
    this.nextStep.emit(nextStep);
    console.log("next", this.data);
  }
  back() {
    this.backStep.emit();
  }
  save() {

  }

  //gestion des datas
  updateData(data) {
    console.log("step update", data, this.data)
    for (let key in data) {
      this.data[key] = data[key];
    }
    console.log("step update", data, this.data)
    this.checkValidForm();
    /*let dataSave = this.data;
    this.data = null;
    this.data = Object.assign(dataSave, data);
    console.log("step update", data, this.data)
    this.checkValidForm();*/
  }
  //pour l'affichage
  testCondition(step: Step) {
    if (step.if) {
      //on valide toutes les conditons
      for (let condition of step.if) {
        if (!(condition.param in this.data) || condition.param in this.data && condition.value != this.data[condition.param]) {
          return false;
        }
      }
      return true;
    }
    else {
      return true;
    }

  }


  initFormCtrl() {
    let formG = {};
    this.dataKeys = [];
    console.log(this.form);
    this.dataKeys = Object.keys(this.form.params);
    let required = false;
    for (let key in this.form.params) {
      if (this.typeWithForm.indexOf(this.form.params[key]) != -1) {
        //condition tempoeraire

        if (key.indexOf("[]") == -1) {
          required = true;
          formG[key] = [this.data[key], Validators.required];
        }
      }
      else {
        if (key.indexOf("[]") == -1) {
          required = true;
        }
      }
    }
    this.enableButtons = !required;
    /*for (let element of this.form.form) {
      for (let widget of element.widgets) {
        console.log(widget);
        if (widget.hasOwnProperty("param")) {
          this.dataKeys.push(widget.param);
          if (widget.param && this.typeWithForm.indexOf(widget.type) != -1) {
            if (typeof widget.param == "string") {
              formG[widget.param] = [this.data[widget.param], Validators.required];
            }
            else {
              if (typeof widget.param == "object") {
                for (let key in widget.param) {
                  formG[widget.param[key]] = [this.data[widget.param[key]], Validators.required];
                }
              }
            }

          }
        }
        else {
          if (widget.type == "ComboBox") {
            for (let value of widget.values) {
              //pb reccursivité combobox
              if ("param" in <any>value) {
                formG[(<any>value).param] = [this.data[(<any>value).param], Validators.required];
              }

            }
          }
        }

      }
    }*/
    console.log("init formgroup", formG);
    this.formGroup = this.fb.group(formG);
    this.formGroup.valueChanges.subscribe(data => {
      this.updateData(data);
    });
  }

  checkValidForm() {
    //temporaire avant d'utilsier les components comme des element de formulaire on check just esi tout est rempli
    if (this.formGroup.status == "VALID") {
      let isValid = true;
      for (let key of this.dataKeys) {
        if (this.data[key] == null) {
          isValid = false;
          break;
        }
      }
      this.enableButtons = true;
    }
    else {
      console.log(this.formGroup);
    }
  }
  makeNgClass(classes: Array<string>) {
    let objClass = {}
    for (let cl of classes) {
      objClass[cl] = true;
    }
    return objClass;
  }
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/steps-wizard/steps-wizard.component.ts